(function () {
  function initBlock(blockEl) {
    if (!blockEl || blockEl.dataset.productDetailsInit === '1') return;

    var popup = blockEl.querySelector('.product-details-popup');
    var trigger = blockEl.querySelector('.product-details-block__trigger');
    var moreBtn = blockEl.querySelector('.product-details-block__more');
    var closeBtn = blockEl.querySelector('.product-details-popup__close');
    var overlay = blockEl.querySelector('.product-details-popup__overlay');
    var content = blockEl.querySelector('.product-details-popup__content');

    if (!popup || !trigger || !closeBtn || !overlay || !content) return;

    blockEl.dataset.productDetailsInit = '1';

    function setExpanded(value) {
      var expanded = value ? 'true' : 'false';
      trigger.setAttribute('aria-expanded', expanded);
      if (moreBtn) {
        moreBtn.setAttribute('aria-expanded', expanded);
      }
    }

    function openPopup(event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      if (popup.parentNode !== document.body) {
        document.body.appendChild(popup);
      }
      popup.style.display = 'block';
      popup.removeAttribute('aria-hidden');
      setExpanded(true);
      requestAnimationFrame(function () {
        popup.classList.add('active');
      });
      document.body.classList.add('overflow-hidden');
    }

    function closePopup() {
      popup.classList.remove('active');
      popup.setAttribute('aria-hidden', 'true');
      setExpanded(false);
      setTimeout(function () {
        popup.style.display = 'none';
        document.body.classList.remove('overflow-hidden');
        if (popup.parentNode === document.body) {
          blockEl.appendChild(popup);
        }
      }, 300);
    }

    trigger.addEventListener('click', openPopup);
    if (moreBtn) {
      moreBtn.addEventListener('click', openPopup);
    }
    closeBtn.addEventListener('click', closePopup);
    overlay.addEventListener('click', closePopup);

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && popup.classList.contains('active')) {
        closePopup();
      }
    });
  }

  function initAll(scope) {
    var root = scope || document;
    root.querySelectorAll('.product-details-block').forEach(initBlock);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll();
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
